import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const dateAfterRefValidationRuleResolver: BaseValidationRuleResolver<string | null> = (
  value,
  rule,
  prop,
  path,
  context
) => {
  const referenceValue = context.getRefValue(prop, path, rule.refId);
  if (value === null || referenceValue === null) {
    return null;
  }

  const date = parseDateOnly(value);
  const referenceDate = parseDateOnly(referenceValue);
  return date !== null && referenceDate !== null && date > referenceDate
    ? null
    : 'Validity date should be later than Version date.';
};

function parseDateOnly(value: unknown): number | null {
  if (typeof value !== 'string') {
    return null;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
    return null;
  }

  return date.getTime();
}
